import React from 'react'
import styles from './index.module.scss'
import cn from 'classnames'
const Card: React.FC<any> = props => {
  return (
    <div className={cn(styles.container, props.className)} style={props.style}>
      {props.children}
    </div>
  )
}
export default Card
